export default __webpack_public_path__ + "static/media/coin_booster.a5ae51f5.svg";